import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  Button,
  Row,
  Space,
  Typography,
  Col,
  Collapse,
  Grid,
  Modal,
  message,
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
import moment from 'moment';
import { API } from 'aws-amplify';

import './priorityBatches.less';
import { ECHOIMAGES } from '../../Assets/Images';
import {
  getCurrentOrganization,
  getCurrnetUserData,
  isAdmin,
  isSuperAdmin,
} from '../../store/slices/loginSlice';
import { listObjective } from '../Goal/GoalFunction';
import {
  createPriorityBatchCustom,
  createPriorityBatchesAndUsersCustom,
} from '../../graphql/customMutation';
import {
  deletePriorityBatches,
  getPriorityBatchCustom,
} from './PriorityFunction';
import { arrToCommaSeperated } from 'utils/commonMethods';
import { getDefaultBatchID } from 'store/slices/compareSlice';
import ScenarioDetailFilterList from './components/ScenarioDetailFilterList';
import { RESTGet, RESTGetAuthorization, RESTScenarioCopy } from 'utils/RESTApi';
import { getOrganizationCustom } from 'utils/Actions';

export default function PriorityBatchDetail({ defaultPriorityBatchDetails }) {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { Panel } = Collapse;
  const { deletePriorityBatch } = ECHOIMAGES.PriorityBatches;
  const currnetOrg = useSelector(getCurrentOrganization);
  const loginUsrOrg = useSelector(getCurrnetUserData);
  const orgId = currnetOrg?.id || loginUsrOrg?.organizationID;
  const userId = currnetOrg?.adminID || loginUsrOrg?.id;
  const userEmail = currnetOrg?.Admin?.email || loginUsrOrg?.email;
  let priorityDefaultBatchID =
    currnetOrg?.defaultPrioirtybatch?.id ||
    loginUsrOrg?.Organization?.organizationDefaultPrioirtybatchId;
  const fetchDefaultBatchID = useSelector(getDefaultBatchID);

  const defaultPriorityBatchID = fetchDefaultBatchID
    ? fetchDefaultBatchID
    : priorityDefaultBatchID;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const isSuperAdminGroup = useSelector(isSuperAdmin);
  const isAdminGroup = useSelector(isAdmin);
  const [showEditButton, setShowEditButton] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [addGoal, setAddGoal] = useState([]);

  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      if (id) {
        let api = `/scenarios/get?organizationID=${orgId}&userID=${userId}&id=${id}`;
        let res = await RESTGetAuthorization(api);
        setItemData(res?.body);

        let ownerIdArray = res?.body?.owners?.map((i) => i.id);
        let disableCondition =
          id === defaultPriorityBatchID
            ? isSuperAdminGroup || isAdminGroup
              ? false
              : true
            : ownerIdArray?.includes(userId) ||
              isSuperAdminGroup ||
              isAdminGroup
            ? false
            : true;
        if (!disableCondition) {
          setShowEditButton(true);
        }
      } else {
        setItemData(defaultPriorityBatchDetails);
      }
    })();
    // eslint-disable-next-line
  }, [defaultPriorityBatchDetails, id, defaultPriorityBatchID]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // list Organization Goal for Leader
  const listGoals = async () => {
    try {
      const filter = {
        organizationObjectivesId: orgId,
      };
      const res = await listObjective(filter);
      const defaultBatches = await getOrganizationCustom({ id: orgId });
      const temp = [];
      res?.data?.objectivesByOrganizationObjectivesId?.items?.forEach((el) => {
        let getPriority =
          itemData?.priorities || defaultPriorityBatchDetails?.priorities;
        const data =
          getPriority &&
          getPriority?.filter((vl) => vl?.ObjectiveID === el?.id);
        if (data?.length > 0) {
          temp.push({ ...data[0], ...el });
        }
      });

      setAddGoal(temp);
    } catch (error) {
      message.error(error.message);
    }
  };

  // create priorities
  const createDuplicatePriorityBatch = async () => {
    try {
      const inputData = {
        id: defaultPriorityBatchDetails?.id || id,
        organizationID: orgId,
        userID: userId,
      };

      await RESTScenarioCopy(inputData);
      message.success('Scenarios duplicate successfully');
      history.push('/priority-batches');
    } catch (err) {
      console.log(err);
    }
  };

  const deletePriorityList = async () => {
    try {
      await deletePriorityBatches({ id: itemData?.id });
      history.push('/priority-batches');
      message.success('Scenarios deleted');
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    listGoals();
    // eslint-disable-next-line
  }, [defaultPriorityBatchDetails, itemData]);

  return (
    <div className="add-idea plr-0 pt-0 overflow-hidden">
      <div className="background-white p-30 mt-20">
        <Row
          justify="space-between"
          align="middle"
          className="pb-20"
          gutter={[0, 20]}
        >
          <Typography.Title level={3} className="mb-0 text-black fs-20">
            {itemData?.title}
          </Typography.Title>

          <Row>
            <Space size={[10, 0]}>
              {(showEditButton || isAdminGroup || isSuperAdminGroup) && (
                <Button
                  className="bordered-button"
                  onClick={() =>
                    history.push({
                      pathname: `/add-priority-batch/${itemData?.id}`,
                    })
                  }
                  size="middle"
                >
                  Edit
                </Button>
              )}
              <Button
                className="bordered-button"
                onClick={createDuplicatePriorityBatch}
                size="middle"
              >
                Duplicate
              </Button>
              {showEditButton && itemData.id !== defaultPriorityBatchID ? (
                <Button
                  className="bordered-button"
                  onClick={showModal}
                  size="middle"
                >
                  Delete
                </Button>
              ) : null}
            </Space>
          </Row>
        </Row>

        <Row className="head-data mt-30 mb-30" gutter={[0, 20]}>
          <Col span={4} lg={4} md={8} sm={24} xs={24}>
            <Typography.Title level={5} className="mb-0 title fs-14">
              No. of goals :
            </Typography.Title>
            <Typography.Title level={5} className="mb-0 mt-0 data fs-14">
              {' '}
              {itemData?.priorities?.length}
            </Typography.Title>
          </Col>
          <Col span={4} lg={4} md={8} sm={24} xs={24}>
            <Typography.Title level={5} className="mb-0 title fs-14">
              Owner :
            </Typography.Title>
            <Typography.Title level={5} className="mb-0 mt-0 data fs-14">
              {' '}
              {itemData?.owners?.length > 0
                ? arrToCommaSeperated(
                    itemData?.owners?.map((item) =>
                      item?.firstName + ' ' + item?.lastName
                        ? item?.firstName + ' ' + item?.lastName
                        : '-'
                    )
                  )
                : '-'}
            </Typography.Title>
          </Col>
          <Col span={4} lg={4} md={8} sm={24} xs={24}>
            <Typography.Title level={5} className="mb-0 title fs-14">
              Type :
            </Typography.Title>
            <Typography.Title level={5} className="mb-0 mt-0 data fs-14">
              {' '}
              {itemData?.public ? 'Shared' : 'Private' || '-'}
            </Typography.Title>
          </Col>
          <Col span={4} lg={4} md={8} sm={24} xs={24}>
            <Typography.Title level={5} className="mb-0 title fs-14">
              Created date :
            </Typography.Title>
            <Typography.Title level={5} className="mb-0 mt-0 data fs-14">
              {' '}
              {moment(itemData?.createdAt).format('l')}
            </Typography.Title>
          </Col>
          <Col span={4} lg={4} md={8} sm={24} xs={24}>
            <Typography.Title level={5} className="mb-0 title fs-14">
              Last modified date :
            </Typography.Title>
            <Typography.Title level={5} className="mb-0 mt-0 data fs-14">
              {' '}
              {moment(itemData?.updatedAt).format('l')}
            </Typography.Title>
          </Col>
        </Row>

        <Row className="detail-page">
          <Col span={24}>
            {addGoal.map((item, index) => {
              return (
                <Collapse
                  key={item?.name}
                  ghost
                  accordion
                  expandIcon={({ isActive }) => (
                    <>
                      <Typography.Title
                        level={5}
                        className="mb-0  fw-500 mr-20 fs-16"
                      >
                        Goal weight :{' '}
                        <span className="text-primary fw-bolder fs-16">
                          {item?.weight}%
                        </span>
                      </Typography.Title>
                      <Typography.Title
                        level={4}
                        className="mb-0 fs-16 fw-500 mt-0 view-more"
                      >
                        <span>
                          {screens.xs
                            ? ''
                            : isActive
                            ? 'View less'
                            : 'View more'}
                        </span>
                        <DownOutlined
                          className="ml-10 more-icon"
                          rotate={isActive ? 180 : 0}
                        />
                      </Typography.Title>
                    </>
                  )}
                  expandIconPosition="end"
                  className={
                    item.active ? 'goal mt-20' : 'goal archive-goal mt-20'
                  }
                >
                  <Panel
                    className="mb-20"
                    key={index}
                    header={
                      <div>
                        <Typography.Title
                          level={5}
                          className="fw-bolder mb-0 fs-18"
                        >
                          {item?.name}
                        </Typography.Title>
                      </div>
                    }
                  >
                    <Row className="head-data mb-20" gutter={[0, 20]}>
                      <Col span={8} lg={8} md={8} sm={24} xs={24}>
                        <Typography.Title
                          level={5}
                          className="mb-0 title fs-14"
                        >
                          Created date :
                        </Typography.Title>
                        <Typography.Title
                          level={5}
                          className="mb-0 mt-0 data fs-14"
                        >
                          {' '}
                          {moment(item?.createdAt).format('l')}
                        </Typography.Title>
                      </Col>
                      <Col span={8} lg={8} md={8} sm={24} xs={24}>
                        <Typography.Title
                          level={5}
                          className="mb-0 title fs-14"
                        >
                          Last modified date :
                        </Typography.Title>
                        <Typography.Title
                          level={5}
                          className="mb-0 mt-0 data fs-14"
                        >
                          {' '}
                          {moment(item?.updatedAt).format('l')}
                        </Typography.Title>
                      </Col>
                      <Col span={8} lg={8} md={8} sm={24} xs={24}>
                        <Typography.Title
                          level={5}
                          className="mb-0 title fs-14"
                        >
                          Owner :
                        </Typography.Title>
                        <Typography.Title
                          level={5}
                          className="mb-0 mt-0 data fs-14"
                        >
                          {' '}
                          {item?.owner?.firstName + ' ' + item?.owner?.lastName}
                        </Typography.Title>
                      </Col>
                    </Row>
                    <p className="goal-details fs-16">{item?.description}</p>
                  </Panel>
                </Collapse>
              );
            })}
          </Col>
        </Row>
        <ScenarioDetailFilterList itemData={itemData} />
      </div>

      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        centered
        okText="Delete"
        className="submit-idea-modal"
        onOk={deletePriorityList}
      >
        <Row justify="center">
          <img src={deletePriorityBatch} alt="" />
          <Typography.Title level={4} className="mt-10">
            Are you sure that you want to delete scenario?
          </Typography.Title>
          <Typography.Title level={5} className="mb-20">
            This action can not be undone.
          </Typography.Title>
        </Row>
      </Modal>
    </div>
  );
}
